import { WalletMA } from "boa-sdk-ts/lib/modules/wallet/WalletMA";
import {getNetworksURL, saveNetworkStatus} from "../utils/WalletUtils";

export const CHANGE_ENDPOINT = "CHANGE_ENDPOINT";

export const changeEndpoint = (endpoint) => (dispatch) => {
  saveNetworkStatus(endpoint);
  WalletMA.instance().setEndpoint(getNetworksURL(endpoint));
  dispatch({
    type: CHANGE_ENDPOINT,
    endpoint: endpoint,
  });
};
